export default __webpack_public_path__ + "static/media/play.2ad85d43.svg";